export const InitialDataTbSetSize = () => {
    return {
        Size_Id: null,
        comp_id: window.localStorage.getItem('company'),
        Size_Code: null,
        Size_Name: null,
        Size_Status: "Y"
    }
}
